import React, { useEffect } from "react";
import MainBanner from "../../Components/Banner/MainBanner";
import Footer from "../../Components/Footer/Footer";
import Header from "../../Components/Header/Header";
import "../../assets/css/Policy.css";
import axios from "axios";
import { ApiHeader, ApiUrl } from "../../network/ApiUrl";
import { useState } from "react";
import { GetCancellation, GetSiteSettingsApi } from "../../network/Network";
import { useDispatch, useSelector } from "react-redux";
import { WebSiteSettings } from "../../redux/actions/AuthActions";
import Skeleton from "react-loading-skeleton";

function Cancelation() {

	const policyData = useSelector((state) => state.AuthReducer.siteSettings?.hoho_cancel_policy);
	const [loading, setLoading] = useState(true);
	const dispatch = useDispatch();
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);
	useEffect(() => {
		setLoading(true);
		GetSiteSettingsApi()
			.then((res) => {
				setLoading(false);
				dispatch(WebSiteSettings(res?.data));
			})
			.catch((err) => {
				setLoading(false);
				// console.log(err);
			});
	}, []);

	return (
		<>
			<Header />
			<MainBanner name={"Cancelation Policy"} />

			<section className="policy-page">
				<div className="container">
					<h2 className="main-title">Our Cancelation policy </h2>
					{loading ?
						<Skeleton count={5} />
						:
						<div dangerouslySetInnerHTML={{ __html: policyData }} className='para'></div>
					}
				</div>
			</section>
			<Footer />
		</>
	);
}

export default Cancelation;
